import React from 'react';
import { TeamScoreModel } from '../../models/scoreBoardModels';
import styles from './penaltyBoard.module.scss';

interface PenaltyBoardProps {
    home: TeamScoreModel;
    away: TeamScoreModel;
}

const PenaltyBoard: React.FC<PenaltyBoardProps> = ({
    home,
    away,
}) => {
    return (
        <div className={styles.penaltyWrapper}>
            {home.hasPenalty ? (
                <div className={styles.homePenalty}>
                    {home.penaltyTime}
                </div>
            ) : null}
            <div className={styles.penaltySeparator}>&nbsp;</div>
            {away.hasPenalty ? (
                <div className={styles.awayPenalty}>
                    {away.penaltyTime}
                </div>
            ) : null}
        </div>
    );
};

export default PenaltyBoard;